import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-instagram-icon/jb-instagram-icon.scss?inline
var jb_instagram_icon_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  display: block;
  height: var(--icon-height, 14.7px);
  width: var(--icon-width, 14.7px);
}

svg {
  height: var(--icon-height, 14.7px);
  width: var(--icon-width, 14.7px);
}`;

// src/components/icons/jb-instagram-icon/jb-instagram-icon.ts
var JbInstagramIcon = class extends r2 {
  render() {
    return ke`
      <svg
        fill="currentColor"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.96288 0.71796C4.18261 0.754773 3.64976 0.879293 3.18395 1.06233C2.70185 1.25021 2.29323 1.50234 1.88667 1.91036C1.4801 2.31839 1.22974 2.7273 1.04318 3.21013C0.862628 3.67697 0.740307 4.21025 0.70584 4.99096C0.671373 5.77167 0.663746 6.02262 0.66756 8.01407C0.671373 10.0055 0.680173 10.2551 0.718014 11.0375C0.755267 11.8176 0.879349 12.3503 1.06239 12.8162C1.25057 13.2983 1.50239 13.7068 1.91057 14.1135C2.31875 14.5202 2.72737 14.77 3.21137 14.9569C3.67778 15.1371 4.21121 15.26 4.99178 15.2942C5.77235 15.3284 6.02359 15.3363 8.01446 15.3325C10.0053 15.3287 10.256 15.3199 11.0382 15.2827C11.8204 15.2456 12.3503 15.1207 12.8164 14.9385C13.2985 14.7499 13.7072 14.4985 14.1137 14.0902C14.5201 13.6819 14.7703 13.2727 14.9567 12.7895C15.1374 12.3231 15.2602 11.7897 15.294 11.0097C15.3282 10.227 15.3363 9.97706 15.3325 7.98591C15.3287 5.99475 15.3197 5.74512 15.2826 4.96309C15.2455 4.18107 15.1213 3.64998 14.9384 3.18373C14.7499 2.70163 14.4984 2.29346 14.0903 1.88646C13.6823 1.47946 13.2728 1.22939 12.7898 1.04341C12.3231 0.862867 11.79 0.739813 11.0094 0.706079C10.2289 0.672346 9.97761 0.663693 7.98601 0.667506C5.9944 0.671319 5.74507 0.679826 4.96288 0.71796ZM5.04854 13.9749C4.33353 13.9438 3.9453 13.825 3.68658 13.7256C3.34396 13.5936 3.0999 13.434 2.84206 13.1787C2.58422 12.9233 2.42582 12.6784 2.29206 12.3365C2.19159 12.0778 2.07059 11.69 2.03715 10.975C2.00077 10.2022 1.99315 9.97017 1.98889 8.01231C1.98464 6.05444 1.99212 5.82271 2.026 5.04963C2.05651 4.33521 2.17604 3.94654 2.27534 3.68797C2.40734 3.34492 2.56633 3.1013 2.82226 2.84361C3.0782 2.58591 3.3224 2.42722 3.66458 2.29346C3.92301 2.19255 4.3108 2.07258 5.02551 2.03855C5.79889 2.00188 6.03063 1.99455 7.98821 1.9903C9.94579 1.98604 10.1781 1.99338 10.9518 2.0274C11.6662 2.0585 12.055 2.17686 12.3133 2.27674C12.6561 2.40874 12.9 2.56729 13.1577 2.82366C13.4154 3.08003 13.5742 3.32336 13.708 3.66626C13.809 3.92396 13.929 4.3116 13.9627 5.02675C13.9995 5.80012 14.0079 6.032 14.0114 7.98943C14.0149 9.94685 14.0081 10.1793 13.9742 10.9521C13.9429 11.6671 13.8244 12.0555 13.7248 12.3145C13.5928 12.657 13.4337 12.9012 13.1776 13.1587C12.9215 13.4163 12.6776 13.575 12.3353 13.7087C12.0772 13.8095 11.6889 13.9297 10.9748 13.9638C10.2014 14.0001 9.96969 14.0078 8.01138 14.012C6.05307 14.0163 5.82207 14.0084 5.04868 13.9749M11.0269 4.0806C11.0272 4.25466 11.0791 4.42472 11.176 4.56928C11.273 4.71384 11.4106 4.82641 11.5715 4.89273C11.7325 4.95906 11.9095 4.97618 12.0801 4.94191C12.2508 4.90765 12.4074 4.82355 12.5303 4.70024C12.6531 4.57694 12.7367 4.41997 12.7703 4.24919C12.8039 4.07841 12.7862 3.90149 12.7193 3.74081C12.6523 3.58013 12.5393 3.4429 12.3944 3.34648C12.2494 3.25006 12.0792 3.19878 11.9051 3.19913C11.6718 3.19959 11.4482 3.29272 11.2835 3.45802C11.1188 3.62331 11.0265 3.84726 11.0269 4.0806ZM4.23468 8.00732C4.23878 10.0871 5.92781 11.7692 8.00713 11.7652C10.0864 11.7613 11.7698 10.0724 11.7658 7.99265C11.7618 5.91291 10.0724 4.23035 7.99275 4.23445C5.91315 4.23856 4.23072 5.92787 4.23468 8.00732ZM5.55557 8.00468C5.55461 7.5212 5.69705 7.0483 5.96486 6.64577C6.23267 6.24325 6.61383 5.92918 7.06014 5.74327C7.50645 5.55737 7.99786 5.50799 8.47224 5.60137C8.94661 5.69476 9.38264 5.92671 9.72519 6.2679C10.0677 6.60909 10.3014 7.0442 10.3967 7.5182C10.4919 7.9922 10.4445 8.4838 10.2604 8.93084C10.0762 9.37788 9.76367 9.76028 9.36221 10.0297C8.96074 10.2991 8.48841 10.4434 8.00493 10.4443C7.6839 10.445 7.36588 10.3824 7.06904 10.2602C6.77219 10.1379 6.50234 9.95842 6.27489 9.73187C6.04744 9.50532 5.86684 9.23618 5.74342 8.93983C5.62 8.64347 5.55617 8.32571 5.55557 8.00468Z"
        />
      </svg>
    `;
  }
};
JbInstagramIcon.styles = r(jb_instagram_icon_default);
JbInstagramIcon = __decorateClass([
  customElement("jb-instagram-icon")
], JbInstagramIcon);

export {
  JbInstagramIcon
};
